import { createRoute, redirect } from '@tanstack/react-router';
import { z } from 'zod';
import { Route as pathlessAuthenticatedRoute } from '../../route';
import { demandSearchSchema } from '../forecast/demand/demandFilters';

/**
 * The demand grid used to live here, with `?view=health` standing in for the
 * run diagnostics. Both now have their own route under `/procurement/forecast`.
 *
 * This exists so links people already sent each other keep working — the whole
 * point of putting the filters in the URL was that a filtered view is
 * shareable, and a 404 on last week's link would undo that. The search params
 * are carried across unchanged, `view=health` included, since that is the one
 * that decides which of the two routes the link meant.
 */
export const Route = createRoute({
  getParentRoute: () => pathlessAuthenticatedRoute,
  path: '/procurement/forecast-runs',
  // `view` is gone from the grid's own schema — it is what this route reads to
  // decide which of the two successors a link meant.
  validateSearch: demandSearchSchema.extend({
    view: z.enum(['health']).optional(),
  }),
  beforeLoad: ({ search }) => {
    const { view, ...rest } = search;
    throw redirect(
      view === 'health'
        ? {
            to: '/procurement/demand-forecasting/runs',
            search: rest.runId ? { runId: rest.runId } : {},
          }
        : { to: '/procurement/forecast/summary', search: rest },
    );
  },
});
